import React from 'react';

function Achievements() {
    return (
        <div>
            <hr />
            <p id='spacing'>
                
                <h3>Masters of Computer Science:</h3>
                <table>
                    <tr>
                        <td><li>CS 442: Mobile App Development</li></td>
                        <td><li>CS 458: Introduction to Information Security</li></td>
                    </tr>
                    <tr>
                        <td><li>CS 480: Introduction to Artificial Intelligence</li></td>

                        <td><li>CS 521: Object-Oriented Analysis & Design</li></td>
                    </tr>
                    <tr>
                        <td><li>CS 525: Advanced Database Organization</li></td>
                        <td><li>CS 539: Game Theory: Algorithms & Appliactions</li></td>
                    </tr>
                    <tr>
                        <td><li>CS 542: Computer Networks I:Fundamentals</li></td>
                        <td><li>CS 584: Machine Learning</li></td>
                    </tr>
                    <tr>
                        <td><li>CS 587: Software Project Management</li></td>

                        <td><li>CSP 554: Big Data Technologies</li></td>
                    </tr>
                    <tr>
                        <td colspan = "2"><li>CSP 584: Enterprise Web Applications</li></td>
                    </tr>
                </table>
                <br />

                <h3>Bachelor of Technology:</h3>
                <table>
                    <tr>
                        <td>
                            Semester I:
                            <li>1101: Engineering Mathematics I</li>
                            <li>1102: Applied Science I</li>
                            <li>1103: Engineering Drawing</li>
                            <li>1104: Electrical Circuits</li>
                            <li>1105: Programming in C</li>
                        </td>
                        <td>
                            Semester II:
                            <li>2101: Engineering Mathematics II</li>
                            <li>2102: Applied Science II</li>
                            <li>2103: Electronic Devices</li>
                            <li>2104: Mechanics & Thermodynamics</li>
                            <li>2105: Communication Skills I</li>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            Semester III:
                            <li>3101: Engineering Mathematics III</li>
                            <li>3102: Digital Logic Circuits</li>
                            <li>3161: Computer Oriented Numerical Methods</li>
                            <li>3162: Discrete Structures & Combinatorics</li>
                            <li>3162: Data Structures & File Processing</li>
                            <li>3164: Principles of Communication Engineering</li>
                        </td>
                        <td>
                            Semester IV:
                            <li>4101: Probability & Random Theory</li>
                            <li>4102: Computer Architecture & Organization</li>
                            <li>4131: System Software</li>
                            <li>4161: Analysis of Algorithm & Complexity</li>
                            <li>4162: Database Management Systems</li>
                            <li>4163: Object Oriented Programming</li>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            Semester V:
                            <li>5101: Communication Skills II</li>
                            <li>5131: Artificial Intelligence</li>
                            <li>5132: Machine Learning</li>
                            <li>5161: Microprocessor and Microcontroller</li>
                            <li>5162: Object Oriented methodology & Design</li>
                            <li>5163: Discrete Time Signal Processing</li>
                        </td>
                        <td>
                            Semester VI:
                            <li>6131: Web Technologies</li>
                            <li>6132: Data Communications & Networking</li>
                            <li>6133: Distributed Information Processing</li>
                            <li>6134: Environmental Science</li>
                            <li>6161: Image Processing</li>
                            <li>6162: Software Engineering</li>
                            <li>Semester Project (IT)</li>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            Semester VII:
                            <li>7531: Mobile Computing</li>
                            <li>7532: Cyber Security & Forensics</li>
                            <li>7533: Data Mining</li>
                            <li>7561: Advanced Databases</li>
                            <li>7762: Data Science & Business Analytics</li>
                            <li>Project Stage I</li>
                        </td>
                        <td>
                            Semester VIII:
                            <li>8561: Cloud Computing</li>
                            <li>8762: Big Data Analytics</li>
                            <li>Project Stage II</li>
                            <li> Project Stage III</li>
                        </td>
                    </tr>
                </table>

            </p>
        </div>
    );
}

export default Achievements;